export default {
  title: 'Popularne produkty',
  list: {
    empty_list: {
      title: 'Brak popularnych produktów.',
    },
    fields: {
      name: 'Nazwa',
      orders: 'Zamówienia',
      sales: 'Sprzedaż',
    },
  },
};
